import TabComponent from "../Tab";
import CutthroatStrategy from "./CutthroatStrategy";
import TeamStrategy from "./TeamStrategy";

const StrategyTab = () => {
  return (
    <TabComponent
      isFitted
      variant="enclosed"
      tab1="Teams - 2v2"
      tab2="Cutthroat"
      tab1Content={<TeamStrategy />}
      tab2Content={<CutthroatStrategy />}
    />
  );
};
export default StrategyTab;
